/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {BufferService} from '../../buffer.service';
import {MeasureService} from '../../../../../shared/services/measure.service';
import {AppConfigState} from '../../../../../../core/state/appConfig/app-config.state';
import {Store} from '@ngxs/store';
import {CreateBuffer} from '../../buffer.actions';

@Component({
    selector: 'dash-gis-buffer-dialog',
    templateUrl: './buffer-dialog.component.html',
})
export class BufferDialogComponent implements OnInit {
    public bufferDistance: number;
    public selectWithin: boolean;

    constructor(
        public dialogRef: MatDialogRef<BufferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private bufferService: BufferService,
        private store: Store,
    ) {}

    public ngOnInit() {}

    public createBuffer(bufferDistance, selectWithin) {
        if (bufferDistance) {
            const distanceInMeters = MeasureService.lengthFeetToMeters(bufferDistance);
            this.store.dispatch(new CreateBuffer(distanceInMeters, selectWithin));
            this.dialogRef.close();
        }
    }

    public onCancel() {
        this.dialogRef.close(false);
    }

    get bufferRanges() {
        return this.store.selectSnapshot(AppConfigState.bufferRanges);
    }
}
